// src/components/Container.tsx
export default function Container({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div
      style={{
        maxWidth: 900,
        margin: "0 auto",
        padding: "0 1rem",
      }}
    >
      {children}
    </div>
  );
}
